export const environment = {
  apiUrl: window.location.hostname.includes('xilo-dev')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-review-app')
    ? 'https://api-dev.xilo.io/api/'
    : window.location.hostname.includes('xilo-staging')
    ? 'https://xilo-staging-api.herokuapp.com/api/'
    : window.location.hostname.includes('localhost')
    ? 'http://localhost:3000/api/'
    : 'https://api.xilo.io/api/',
  workflowApiUrl: window.location.hostname.includes('xilo-dev')
    ? 'https://workflows-api-dev.xilo.io/api/'
    : window.location.hostname.includes('localhost')
    ? 'http://localhost:3333/api/'
    : 'https://workflows-api.xilo.io/api/'
};
